import React from "react";
import { Switch, Route } from "react-router-dom";
import BorderSpaceView from "presentational/common/BorderSpaceView";
import HeaderView from "presentational/HeaderView";
import FooterArea from "presentational/common/FooterArea";
import {
  OpeningPage,
  OutfitDetailPage,
  ItemDetailPage,
  SearchPage,
  UploadOutfitPage,
  UploadItemPage,
  UploadProfileImgPage,
  ChangePasswordPage,
  ChangeUsernamePage,
  AccountPage,
  MembershipPage,
  AboutPage,
  TermsPage,
  PrivacyPage,
  PortfolioPage,
  GoogleLoginCallbackPage,
  ShortcutOutfitPage,
  ShortcutPortfolioHashPage,
  ShortcutPortfolioUsernamePage
} from "pages";

function MainRouter(props) {
  return (
    <div>
      <HeaderView />
      <BorderSpaceView>
        <Switch>
          <Route exact path="/" component={OpeningPage} />
          <Route exact path="/lookbook" component={OpeningPage} />
          <Route path="/outfit/:outfitHash" component={OutfitDetailPage} />
          <Route path="/item/:itemHash" component={ItemDetailPage} />
          <Route path="/search" component={SearchPage} />
          <Route exact path="/upload/outfit" component={UploadOutfitPage} />
          <Route exact path="/upload/item" component={UploadItemPage} />
          <Route
            exact
            path="/upload/profile"
            component={UploadProfileImgPage}
          />
          <Route exact path="/change/password" component={ChangePasswordPage} />
          <Route exact path="/change/username" component={ChangeUsernamePage} />
          <Route exact path="/account" component={AccountPage} />
          <Route exact path="/membership" component={MembershipPage} />
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/auth/callback" component={GoogleLoginCallbackPage} />
          <Route path="/terms-of-use/:language" component={TermsPage} />
          <Route path="/terms-of-use" component={TermsPage} />
          <Route path="/privacy-policy/:language" component={PrivacyPage} />
          <Route path="/privacy-policy" component={PrivacyPage} />
          <Route path="/user/:name" component={PortfolioPage} />
          <Route path="/o/:outfitHash" component={ShortcutOutfitPage} />
          <Route path="/u/:name" component={ShortcutPortfolioUsernamePage} />
          <Route path="/:userHash" component={ShortcutPortfolioHashPage} />
        </Switch>
        <FooterArea />
      </BorderSpaceView>
    </div>
  );
}

export default MainRouter;
